// extracted by mini-css-extract-plugin
export default {"buttonContainer":"FullscreenButton_buttonContainer__2IskO","fullscreenHint":"FullscreenButton_fullscreenHint__0Z2SA"};